import React from 'react';
import { useNavigate } from 'react-router';
import { TableReact } from 'common/components/table';
import { useTranslation } from 'common/i18n/hooks';
import { getReportUrl } from 'common/report/util';
import { useFeatureFlagStore } from 'apps/feature-flags/src/store';
import { FeatureFlagStatus } from 'app_api/projects/feature_flags/types';
import { useFeatureFlagPageContext } from 'iron/apps/feature-flags/src/components/context';
import { DogfoodingBanner } from 'common/content/list-page/dogfooding-banner';
import styles from './index.module.styl';
import tableStyles from './table.inline.styl';
import cellRendererStyles from './cell-renderer.module.styl?inline';
import { CreatorCell, FormattedDateCell, RenderCellLabel } from './cell-renderer';
function statusSortValue(status: FeatureFlagStatus) {
  switch (status) {
    case "enabled":
      return 1;
    case "disabled":
      return 2;
    case "archived":
      return 3;
    default:
      return 0;
  }
}
export function FeatureFlagListMain() {
  const featureFlags = useFeatureFlagStore(state => state.featureFlags);
  const i18n = useTranslation();
  const navigate = useNavigate();
  const {
    projectId,
    workspaceId
  } = useFeatureFlagPageContext();
  return <main className={styles.main} data-sentry-component="FeatureFlagListMain" data-sentry-source-file="index.tsx">
      <DogfoodingBanner percentComplete={30} slackChannelName={"project-experiment-reporting"} slackChannelId={"C0547DQTVCN"} projectId={projectId} data-sentry-element="DogfoodingBanner" data-sentry-source-file="index.tsx" />
      <TableReact allow-x-overflow={false} trackName='feature-flags' defaultSortField='name' loading={featureFlags === undefined} style-override={tableStyles + cellRendererStyles} rows={featureFlags} onRowClick={_ref => {
      let {
        detail
      } = _ref;
      navigate(getReportUrl("feature-flags/".concat(detail.row.id), {
        projectId,
        workspaceId
      }));
    }} columns={[{
      title: i18n.t("feature-flags.list.column-name"),
      field: "name",
      isSearchable: true,
      flexBasis: "200px"
    }, {
      title: i18n.t("feature-flags.list.column-key"),
      field: "key",
      isSearchable: true,
      flexBasis: "200px"
    }, {
      title: i18n.t("feature-flags.list.column-status"),
      field: "status",
      isSortable: true,
      flexBasis: "140px",
      sortTransform(row) {
        return statusSortValue(row.status);
      },
      cellRenderer(row) {
        const status: FeatureFlagStatus = row.status;
        return RenderCellLabel({
          label: i18n.t("feature-flags.status.".concat(status)),
          className: "status-".concat(row.status)
        });
      }
    }, {
      title: i18n.t("feature-flags.list.column-creator"),
      field: "creator",
      isSearchable: true,
      flexBasis: "140px",
      cellRenderer(row) {
        return CreatorCell({
          id: row.creator_id,
          name: row.creator_name,
          email: row.creator_email
        });
      }
    }, {
      title: i18n.t("feature-flags.list.column-lastmodified"),
      field: "modified",
      isSearchable: true,
      isSortable: true,
      flexBasis: "200px",
      cellRenderer(row) {
        return FormattedDateCell(row.modified, i18n);
      }
    }]} data-sentry-element="TableReact" data-sentry-source-file="index.tsx" />
    </main>;
}